import fetchModels from "../../mixin/store/api/fetchModels";

export default {
    actions: {
        fetchCurrencies(context) {
            if (context.getters.getCurrencies.length > 0) {
                return
            }

            return fetchModels(context, 'currencies', null, 'updateCurrencies')
        },
    },
    mutations: {
        updateCurrencies(state, data) {
            state.currencies = data
        }
    },
    state: {
        currencies: {
            models: [],
            totalItems: 0,
        },
    },
    getters: {
        getCurrency: (state, getters) => (id) => {
            return getters.getCurrencies.find( model => model.id === id )
        },
        getCurrencyByShortName: (state, getters) => (shortName) => {
            return getters.getCurrencies.find( model => model.shortName === shortName )
        },
        getCurrencies(state) {
            return state.currencies.models
        }
    },
}
